module.exports = __webpack_public_path__ + "static/media/website_load_xmas_1.bad44d46.png";